// extracted by mini-css-extract-plugin
export default {"container":"cg_d","icon":"cg_hj","iconTick":"cg_jP","title":"cg_c0","subtitle":"cg_hk"};